import { render, staticRenderFns } from "./DebugPanel.vue?vue&type=template&id=3baa6e58&scoped=true&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/DebugPanel?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/DebugPanel?vue&type=script&lang=js&"
import style0 from "./DebugPanel.vue?vue&type=style&index=0&id=3baa6e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa6e58",
  null
  
)

export default component.exports